<template>
  <b-modal
    v-model="showModal"
    centered
    hide-header
    hide-footer
    size="lg"
    modal-class="notice-modal"
    @hidden="onClose"
  >
    <div class="notice-content">
      <!-- 左侧内容区 -->
      <div class="notice-left">
        <div class="logo">
          <img src="/logo.ico" alt="天晟科技" />
          <span class="company-name">天晟科技</span>
        </div>

        <div class="notice-text">
          <p class="tw-text-textMain tw-text-sm">尊敬的客户：</p>
          <p class="tw-text-textMain tw-text-sm">
            感谢您一直以来对天晟的支持与信任！
          </p>
          <p class="tw-text-textMain tw-text-sm">
            值此新春佳节来临之际，根据国家相关规定并结合我司实际情况，现将2026年春节假期安排公告如下：
          </p>

          <div>
            <p class="tw-text-textMain tw-text-sm">一、放假时间</p>
            <p class="tw-text-textMain tw-text-sm">
              2026年2月7日（星期六）至2026年2月25日（星期三）放假，共19天。
            </p>
          </div>

          <div>
            <p class="tw-text-textMain tw-text-sm">二、上班时间</p>
            <p class="tw-text-textMain tw-text-sm">
              2026年2月26日（星期四）起，公司全体员工恢复正常办公。
            </p>
          </div>

          <p class="tw-text-textMain tw-text-sm">
            假期期间，如有紧急事务，您可通过官方问题反馈留言，我们将在节后尽快为您处理。给您带来的不便，敬请谅解。
          </p>

          <p class="tw-text-textMain tw-text-sm">
            预祝您新春快乐，阖家幸福，万事如意！
          </p>
        </div>

        <button class="confirm-btn" @click="handleConfirm">我已知晓</button>
      </div>

      <!-- 右侧图片区 -->
      <div class="notice-right">
        <img src="/notice.png" alt="2026" class="notice-image" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { readNoticeApi } from "@/api/personalCenter/index";

export default {
  name: "NoticeModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    noticeId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    visible: {
      handler(val) {
        this.showModal = val;
      },
      immediate: true,
    },
  },
  methods: {
    async handleConfirm() {
      const userInfo = localStorage.getItem("userInfo");
      const isLoggedIn = !!userInfo;

      if (isLoggedIn && this.noticeId) {
        try {
          await readNoticeApi(this.noticeId);
        } catch (error) {
          console.error("标记公告已读失败:", error);
        }
      }

      this.showModal = false;
      this.$emit("close");
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.notice-content {
  display: flex;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  min-height: 500px;

  .notice-left {
    flex: 1;
    padding: 40px;
    display: flex;
    flex-direction: column;
    background: white;

    .logo {
      display: flex;
      align-items: center;
      margin-bottom: 24px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }

      .company-name {
        font-size: 18px;
        font-weight: 600;
        color: #333;
      }
    }

    .notice-text {
      flex: 1;
      font-size: 14px;
      line-height: 1.8;
      color: #333;

      p {
        margin-bottom: 12px;
      }
    }

    .confirm-btn {
      width: 100%;
      padding: 12px 24px;
      background: linear-gradient(90deg, #4077f8 0%, #3d4bdf 100%);
      color: white;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s;
      margin-top: 20px;
    }
  }

  .notice-right {
    width: 300px;
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    display: flex;
    align-items: center;
    justify-content: center;

    .notice-image {
      width: 100%;
      height: auto;
      object-fit: contain;
    }
  }
}

::v-deep .notice-modal {
  .modal-dialog {
    max-width: 900px;
  }

  .modal-content {
    border: none;
    border-radius: 12px;
    overflow: hidden;
  }

  .modal-body {
    padding: 0;
  }
}

@media (max-width: 768px) {
  .notice-content {
    flex-direction: column;

    .notice-left {
      padding: 24px;
    }

    .notice-right {
      width: 100%;
      min-height: 200px;
    }
  }
}
</style>
